import React from 'react';
import type { PageProps } from './page';
import { Page } from './page';

export const Cancelled = (props: Pick<PageProps, 'className' | 'reset'>): React.ReactElement => (
  <Page code={'This event has been canceled.'} message='Please reach out to the host organization with any questions.' {...props} />
);
